// extracted by mini-css-extract-plugin
module.exports = {"overflowFade":"_3J74XsK"};